var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAtm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-1.13249e-06 2.26667V8.26074C-1.13249e-06 9.68119 0.861537 10.5274 2.30769 10.5274H2.51282C2.68205 10.5274 2.82051 10.3914 2.82051 10.2252V3.5763C2.82051 3.41007 2.95897 3.27407 3.1282 3.27407H16.8718C17.041 3.27407 17.1795 3.41007 17.1795 3.5763V10.2252C17.1795 10.3914 17.3179 10.5274 17.4872 10.5274H17.6923C19.1385 10.5274 20 9.68119 20 8.26074V2.26667C20 0.846222 19.1385 0 17.6923 0H2.30769C0.861537 0 -1.13249e-06 0.846222 -1.13249e-06 2.26667ZM4.35897 5.08741V15.8667C4.35897 17.5364 5.7359 18.8889 7.4359 18.8889H12.5641C14.2641 18.8889 15.641 17.5364 15.641 15.8667V5.08741C15.641 4.92119 15.5026 4.78519 15.3333 4.78519H4.66667C4.49744 4.78519 4.35897 4.92119 4.35897 5.08741ZM8.97436 15.368C8.97436 14.8114 9.43333 14.3606 10 14.3606C10.5667 14.3606 11.0256 14.8114 11.0256 15.368C11.0256 15.9246 10.5667 16.3754 10 16.3754C9.43333 16.3754 8.97436 15.9246 8.97436 15.368ZM7.69231 10.0741C7.69231 8.82237 8.72564 7.80741 10 7.80741C11.2744 7.80741 12.3077 8.82237 12.3077 10.0741C12.3077 11.3258 11.2744 12.3407 10 12.3407C8.72564 12.3407 7.69231 11.3258 7.69231 10.0741Z",
    fill: "#2C2B38"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtm);
export default __webpack_public_path__ + "static/media/atm.8c2175c81ddd0496c9539b08eed91314.svg";
export { ForwardRef as ReactComponent };